module.exports = __webpack_public_path__ + "img/bj2.59114575.jpg";